import { ICompany } from 'app/shared/model/company.model';

export interface ITireManufacturer {
  id?: number;
  name?: string | null;
  imageContentType?: string | null;
  image?: string | null;
  type?: string | null;  
  company?: ICompany | null;
}

export const defaultValue: Readonly<ITireManufacturer> = {};
